import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { WallCaption } from './WallCaption';
import { AnnaWordmark } from '../ui/AnnaWordmark';
import type { AnnaStage } from '../../hooks/useAnnaStage';
interface CaptionAreaProps {
  stage: AnnaStage;
  nothingGoingOn: boolean;
  compact?: boolean;
  /** Wordmark size in px — matches the boot overlay, so the opening hands over into this */
  wordmark?: number;
}
const EASE = [0.23, 1, 0.32, 1] as const;
const fade = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  transition: {
    duration: 0.3
  }
};
function ambientLine(waiting: number) {
  if (waiting === 0) return 'Rustig in huis. Niets wacht op je.';
  if (waiting === 1) return 'Rustig in huis. 1 ding wacht op je, niets dringends.';
  return `Rustig in huis. ${waiting} dingen wachten op je, niets dringends.`;
}

/**
 * Directly under Anna: her live caption, the quiet-mode line, or — when nothing has been asked —
 * her name, exactly as the boot sequence left it, with one line on the state of the house.
 */
export function CaptionArea({
  stage,
  nothingGoingOn,
  compact = false,
  wordmark = 64
}: CaptionAreaProps) {
  return <AnimatePresence mode="wait" data-id="element-1432" data-mp="37fhxhr645kgs">
      {stage.caption ? <motion.div key={stage.caption.id} initial={{
      opacity: 1
    }} exit={{
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: EASE
      }
    }} data-id="element-1433" data-mp="37f88o6wt1jco">
          <WallCaption text={stage.caption.text} revealed={stage.revealed} compact={compact} data-id="element-1434" data-mp="2yn6ciktrqp87" />
        </motion.div> : stage.quietLine && stage.view === 'stage' ? <motion.p key="quiet" {...fade} className="text-[26px] text-amber" data-id="element-1435" data-mp="33f7mu17dm5vl">
          {stage.quietLine}
        </motion.p> : nothingGoingOn ? <motion.div key="ambient" {...fade} className="flex flex-col items-center" data-id="element-1436" data-mp="2tna7ci9c4rr2">
          <AnnaWordmark size={wordmark} data-id="element-1437" data-mp="2fok6crjea7xf" />
          <p className={`mt-3 text-ink-soft ${wordmark >= 64 ? 'text-[24px]' : 'text-[16px]'}`} data-id="element-1438" data-mp="2fou1etjar59z">{ambientLine(stage.pending.length)}</p>
        </motion.div> : null}
    </AnimatePresence>;
}